export const apiNameRegex =
    /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$|^(([a-zA-Z0-9]|[a-zA-Z0-9][a-zA-Z0-9-]*[a-zA-Z0-9])\.)+([A-Za-z]|[A-Za-z][A-Za-z0-9-]*[A-Za-z0-9])$/;

export const scopeRoleNameRegex = /^(?![.-])(?!.*[.-][.-])[a-z.-]*(?<![.-])$/;

export const uriRegex = /^$|^[0-9a-z.]*:\/\/[a-z0-9./]*/;
export const redirectUriRegex =
    /^(?:$|[a-zA-Z][a-zA-Z0-9+.-]*:\/\/(?:[^/?#\s*]*)(?:\/[^?#\s*]*)?(?:\?[^#\s*]*)?(?:#[^\s*]*)?|[a-zA-Z][a-zA-Z0-9+.-]*:\/\/[^/?#:[\]@*]+:\*(?:\/[^?#]*)?(?:\?[^#]*)?(?:#.*)?)$/;
export const notEndsWithSlash = /(?<![/])$/;
export const validCorsOrigin =
    /^(?:https?:\/\/(?:[a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+(?:\.[a-zA-Z]{2,})?(?::(?:\*|\d{1,5}))?|[a-zA-Z][a-zA-Z0-9+.-]*:\/\/[^/?#\s:*]+(?::\d{1,5})?)$/;
export const guidRegex =
    /^(?:\{{0,1}(?:[0-9a-fA-F]){8}-(?:[0-9a-fA-F]){4}-(?:[0-9a-fA-F]){4}-(?:[0-9a-fA-F]){4}-(?:[0-9a-fA-F]){12}\}{0,1})$/;
